import React from 'react';
import MainContentGridContainerQuery from '@/components/common/MainContentGridContainerQuery';
import SummaryStatsContainer from '@/components/common/SummaryStats/SummaryStatsContainer';
import SummaryStatsHeader from '@/components/common/SummaryStats/SummaryStatsHeader';
import translate from '@/lib/intl/translate';
import type ConstituentIWaveProfile from '@/types/api/ConstituentIWaveProfile';
import IWaveSummaryRenderList from '../constants/IWaveSummaryRenderList';
import IWaveScoreEvaluation from './IWaveScoreEvaluation';

export default function ConstituentIWaveScoreBreakdown({
  iwaveProfile,
}: {
  iwaveProfile: ConstituentIWaveProfile;
}) {
  return (
    <div>
      <h2 className="mb-4 type-h2">
        {translate('IWAVE_SCORE_BREAKDOWN_HEADER')}
      </h2>

      <MainContentGridContainerQuery>
        {IWaveSummaryRenderList.map(({ description, header, stat }) => {
          const score = iwaveProfile[stat];

          return (
            <SummaryStatsContainer key={stat} className="justify-between gap-2">
              <SummaryStatsHeader className="text-grey-900">
                {header}
              </SummaryStatsHeader>

              <IWaveScoreEvaluation
                className="type-h2"
                score={score}
                withColor
              />

              <p className="text-grey-900 type-body1">{description}</p>
            </SummaryStatsContainer>
          );
        })}
      </MainContentGridContainerQuery>
    </div>
  );
}
